import { useMemo } from 'react';
import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { AIInsights, MetricsType } from '../domain/ai-insights';

type AIInsightsHook = {
  footTrafficAiInsights: AIInsights | null;
  rsaAiInsights: AIInsights | null;
};

export const useLciAIInsights = (
  report: Lci3Report | null,
  metricsType: MetricsType,
  dimension: string | null = null
): AIInsightsHook => {
  return useMemo(() => {
    if (!report) {
      return { footTrafficAiInsights: null, rsaAiInsights: null };
    }

    const rsaAiInsights = (report.rsaAIInsights ?? []).find(
      i => i.metricsType === metricsType && i.dimensionName === dimension
    );
    const footTrafficAiInsights = (report.footTrafficAIInsights ?? []).find(
      i => i.metricsType === metricsType && i.dimensionName === dimension
    );

    return {
      footTrafficAiInsights: footTrafficAiInsights ?? null,
      rsaAiInsights: rsaAiInsights ?? null,
    };
  }, [dimension, metricsType, report]);
};
